export const INIT_REALTIME = "INIT_REALTIME"
export const UPDATE_REALTIME = "UPDATE_REALTIME"